//Function Hamburger Menu
jQuery(".menu-button, .close, .backdrop").click(function (e) {
  e.preventDefault();
  jQuery("#nav-hamburger").toggleClass("show");
  jQuery("body").toggleClass("scroll");
});
//Function Hamburger Menu
jQuery(".menu-button-sticky, .close-sticky, .backdrop-sticky").click(function (e) {
  e.preventDefault();
  jQuery("#sticky-hamburger").toggleClass("show");
  jQuery("body").toggleClass("scroll");
});

// Slick Slider Header
jQuery(function (jQuery) {
  jQuery(".slick-slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
  });

});

// Slick Slider Publicaties - Mobile
jQuery(function (jQuery) {
  jQuery(".publicaties-slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  });
});

// Slick Slider Publicaties Archive - Categories - Mobile
jQuery(function (jQuery) {
  jQuery(".categories-mobile-slider").slick({
    dots: false,
    rows: 1,
    infinite: true,
    speed: 300,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});

// Slick Slider Gemeenten en Organisaties - Mobile
jQuery(function (jQuery) {
  jQuery(".gemeenten-slider").slick({
    rows: 2,
    dots: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    speed: 300,
    variableWidth: false,
  });
});



// $classes = preg_replace('/(current(-menu-|[-_]page[-_])(item|parent|ancestor))/', 'active', $classes);


// Add Active Class To Category Menu - Publicaties Archive
// jQuery(document).ready(function () {
//   jQuery('.archive-publicaties .menu .categories li a').click(function () {
//     jQuery('.archive-publicaties .menu .categories li a').removeClass("active");
//     jQuery(this).addClass("active"); $(window).load()
//   });
// });

// autocomplete search
jQuery('#autocomplete').keyup(function (e) {
  if (jQuery(this).val().length > 2) {
    jQuery.ajax({
      type: 'post',
      url: WPAjax.ajaxurl,
      data: {
        action: 'load_search_results',
        query: jQuery(this).val()
      },
      beforeSend: function () {
        // $input.prop('disabled', true);
        // $content.addClass('loading');
      },
      success: function (response) {

        data = jQuery.parseJSON(response);
        jQuery('#autocompleteul').empty().show();
        jQuery.each(data, function (i, item) {
          if (item['link'] !== '') {
            jQuery('#autocompleteul').append('<li><a href="' + item['link'] + '">' + item['title'] + '</a></li>');
          } else {
            jQuery('#autocompleteul').append('<li class="title">' + item['title'] + '</li>');
          }

        });
      }
    });
  } else {
    jQuery('#autocompleteul').empty().hide();
  }
});

// autocomplete search
jQuery('#autocompleteinner').keyup(function (e) {
  if (jQuery(this).val().length > 2) {
    jQuery.ajax({
      type: 'post',
      url: WPAjax.ajaxurl,
      data: {
        action: 'load_search_results',
        query: jQuery(this).val()
      },
      beforeSend: function () {
        // $input.prop('disabled', true);
        // $content.addClass('loading');
      },
      success: function (response) {

        data = jQuery.parseJSON(response);
        jQuery('#autocompleteulinner').empty().show();
        jQuery.each(data, function (i, item) {
          if (item['link'] !== '') {
            jQuery('#autocompleteulinner').append('<li><a href="' + item['link'] + '">' + item['title'] + '</a></li>');
          } else {
            jQuery('#autocompleteulinner').append('<li class="title">' + item['title'] + '</li>');
          }

        });
      }
    });
  } else {
    jQuery('#autocompleteulinner').empty().hide();
  }
});

jQuery(".slick-menu").slick({
  dots: false,
  arrows: true,
  adaptiveHeight: true,
  infinite: false
});

// sticky menu
window.addEventListener("scroll", bringmenu);
function bringmenu() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    document.getElementById("menu-sticky").style.top = "0";
  } else {
    document.getElementById("menu-sticky").style.top = "-100%";
  }
}


jQuery('.file_upload').change(function () {
  var filename = jQuery('#input_3_19')[0].files[0].name;


  jQuery('.ginput_container_fileupload').after('<div class="filename">Bijlage: ' + filename + '</div>');

});